var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.graduatedPrices[0]
    ? _c("div", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$translate("Ceres::Template.singleItemGraduatedPrices")
            ) + ":"
          )
        ]),
        _vm._v(" "),
        _c("table", { staticClass: "graduated-prices-table text-muted" }, [
          _c(
            "tbody",
            [
              _vm._l(_vm.graduatedPrices, function(price, index) {
                return [
                  _c("tr", [
                    _c(
                      "td",
                      {
                        class: _vm.paddingClasses,
                        style: _vm.paddingInlineStyles
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "Ceres::Template.singleItemMinimumQuantity"
                            )
                          ) +
                            " " +
                            _vm._s(price.minimumOrderQuantity)
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "graduated-price",
                        class: _vm.paddingClasses,
                        style: _vm.paddingInlineStyles
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(price.unitPrice.formatted) +
                            "\n                        "
                        ),
                        _c("transition", { attrs: { name: "fade" } }, [
                          index === _vm.activeGraduationIndex
                            ? _c("i", {
                                staticClass:
                                  "fa fa-lg fa-check-circle-o text-appearance",
                                attrs: { "aria-hidden": "true" }
                              })
                            : _vm._e()
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.showBasePrice
                      ? _c(
                          "td",
                          {
                            staticClass:
                              "graduated-base-price pl-3 d-none d-xl-block",
                            class: _vm.paddingClasses,
                            style: _vm.paddingInlineStyles
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.singleItemGraduatedBasePrice",
                                  { price: price.basePrice }
                                )
                              )
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.showBasePrice
                    ? _c(
                        "tr",
                        { staticClass: "graduated-base-price d-xl-none" },
                        [
                          _c("td", {
                            class: _vm.paddingClasses,
                            style: _vm.paddingInlineStyles
                          }),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              class: _vm.paddingClasses,
                              style: _vm.paddingInlineStyles
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.singleItemGraduatedBasePrice",
                                    { price: price.basePrice }
                                  )
                                )
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ]
              })
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("br")
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }